import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { CalendarMode } from "PFApp/booking/types";

export type KnownParams = Partial<{
  mode: CalendarMode | null;
  bookingId: number | null;
  activityId: number | null;
  workforceMemberId: number | null;
  overbookings: boolean | null;
  openAllocateManually: boolean | null;
}>;

export type ActionResult = { calendarMode?: CalendarMode };

export enum ActionType {
  ShowInTab,
  ShowDetailsPanel
}

export const parseActionType = (action: string | null): ActionType | null => {
  if (action && Object.values(ActionType).includes(Number(action))) {
    return action as unknown as ActionType;
  }
  return null;
};

const isCalendarMode = (mode: string | null): mode is CalendarMode =>
  !!mode && Object.values<string>(CalendarMode).includes(mode);

export const getParams = (searchParams: URLSearchParams): KnownParams => {
  const mode = searchParams.get("mode");
  const bookingId = searchParams.get("bookingId");
  const activityId = searchParams.get("activityId");
  const workforceMemberId = searchParams.get("workforceMemberId");
  const overbookings = searchParams.get("overbookings");
  const openAllocateManually = searchParams.get("openAllocateManually");
  return {
    mode: isCalendarMode(mode) ? (mode as CalendarMode) : null,
    bookingId: !isNil(bookingId) && !isEmpty(bookingId) ? parseInt(bookingId) : null,
    activityId: !isNil(activityId) && !isEmpty(activityId) ? parseInt(activityId) : null,
    workforceMemberId:
      !isNil(workforceMemberId) && !isEmpty(workforceMemberId) ? parseInt(workforceMemberId) : null,
    overbookings: !!overbookings,
    openAllocateManually: !!openAllocateManually
  };
};
